<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-datepicker v-model="startDate" :md-immediately="true">
          <label>Từ ngày</label>
        </md-datepicker>
      </div>
      <div class="md-layout-item">
        <md-datepicker v-model="endDate" :md-immediately="true">
          <label>Đến ngày</label>
        </md-datepicker>
      </div>
      <div class="md-layout-item">
        <md-field class="md-layout-item">
          <label>Loại giao dịch</label>
          <md-select v-model="type">
            <md-option value="Tất cả">Tất cả</md-option>
            <md-option value="Cộng tiền">Cộng tiền</md-option>
            <md-option value="Trừ tiền">Trừ tiền</md-option>
          </md-select>
        </md-field>
      </div>
      <!-- <div class="md-layout-item">
        <md-button class="md-info md-just-icon md-round" @click="startFilter()">
          <md-icon>filter_alt</md-icon>
          <md-tooltip>Lọc, tìm kiếm</md-tooltip>
        </md-button>
      </div> -->
    </div>
    <div>
      <md-table
        :value="queriedData"
        class="table-hover table-border"
        table-header-color="green"
      >
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          v-bind:class="{ deposit: item.data.isDeposit }"
        >
          <md-table-cell md-label="Thời gian" class="table-cell" align="left">
            {{ formatDate(new Date(item.data.time)) }}
          </md-table-cell>
          <md-table-cell
            md-label="Loại giao dịch"
            class="table-cell"
            align="left"
          >
            {{ item.data.isDeposit ? "Cộng tiền" : "trừ tiền" }}
          </md-table-cell>
          <md-table-cell
            md-label="Số tiền"
            class="table-cell"
            align="left"
            md-numeric
          >
            {{ formatNumber(item.data.amount) }}
          </md-table-cell>
          <md-table-cell
            md-label="Số dư"
            class="table-cell"
            align="left"
            md-numeric
          >
            {{ formatNumber(item.data.deposit) }}
          </md-table-cell>
          <!-- <md-table-cell
            md-label="So sánh"
            class="table-cell"
            align="left"
            md-numeric
          >
            {{ formatNumber(item.data.afterChange) }}
          </md-table-cell> -->
          <md-table-cell md-label="Ghi chú" class="table-cell" align="left">
            {{ item.data.note }}
          </md-table-cell>
          <md-table-cell
            md-label="Đối tượng thay đổi"
            class="table-cell"
            align="left"
          >
            {{ item.data.admin }}
          </md-table-cell>
        </md-table-row>
      </md-table>
      <div class="formActions">
        <div>
          <p class="card-category">Hiển thị từ {{ from + 1 }} đến {{ to }}</p>
        </div>
        <span v-show="queriedData.length < pagination.perPage"
          >Đã tải hết dữ liệu</span
        >
        <div class="pagination clickable">
          <div
            style="margin-right: 10px"
            @click="previusPage"
            v-show="pagination.currentPage !== 1"
            class="md-alignment-center-center md-layout"
          >
            <md-button class="md-simple md-sm">
              <i class="fas fa-angle-double-left"></i>
              Trang trước
            </md-button>
          </div>
          <div
            @click="nextPage"
            v-show="queriedData.length === pagination.perPage"
            class="md-alignment-center-center md-layout"
          >
            <md-button class="md-simple md-sm">
              Trang sau
              <i class="fas fa-angle-double-right"></i>
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "../../EventBus";
export default {
  props: ["db", "user"],
  data() {
    return {
      startDate: null,
      endDate: null,
      type: "Tất cả",
      listTransactions: [],
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },

  created() {
    this.getData(this.pagination.perPage * 2);
  },

  mounted() {
    EventBus.$on("reloadHistory", () => {
      this.listTransactions = [];
      this.getData(this.pagination.perPage * 2);
    });
  },

  methods: {
    getData(num) {
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      let query = this.db.collection(process.env.VUE_APP_DEPOSIT_RECORD + bits);
      if (this.startDate) {
        query = query.where("time", ">=", this.startDate.getTime());
      }
      if (this.endDate) {
        query = query.where("time", "<=", this.endDate.getTime() + 86400000);
      }
      if (this.type !== "Tất cả") {
        query = query.where(
          "isDeposit",
          "==",
          this.type === "Cộng tiền" ? true : false
        );
      }

      query
        .where(
          "time",
          "<",
          this.listTransactions[this.listTransactions.length - 1]
            ? this.listTransactions[this.listTransactions.length - 1].data.time
            : new Date().getTime()
        )
        .where("employeeCode", "==", this.user.data.employeeCode)
        .orderBy("time", "desc")
        .limit(num ? num : this.pagination.perPage)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            this.listTransactions.push({
              id: item.id,
              data: item.data(),
            });
            if (this.listTransactions.length === 1) {
              this.listTransactions[0].data.deposit = this.user.data.deposit;
            } else {
              if (
                this.listTransactions[this.listTransactions.length - 2].data
                  .isDeposit
              )
                this.listTransactions[
                  this.listTransactions.length - 1
                ].data.deposit =
                  this.listTransactions[this.listTransactions.length - 2].data
                    .deposit -
                  this.listTransactions[this.listTransactions.length - 2].data
                    .amount;
              else
                this.listTransactions[
                  this.listTransactions.length - 1
                ].data.deposit =
                  this.listTransactions[this.listTransactions.length - 2].data
                    .deposit +
                  this.listTransactions[this.listTransactions.length - 2].data
                    .amount;
            }
          });
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    startFilter() {
      this.listTransactions = [];
      this.getData(this.pagination.perPage * 2);
    },

    previusPage() {
      if (this.pagination.currentPage !== 1) {
        this.pagination.currentPage--;
      }
    },

    async nextPage() {
      if (
        this.queriedData[this.queriedData.length - 1] ===
          this.listTransactions[
            this.listTransactions.length - 1 - this.pagination.perPage
          ] &&
        this.queriedData.length === this.pagination.perPage
      ) {
        this.pagination.currentPage++;
        await this.getData(null);
      } else if (
        this.queriedData[this.queriedData.length - 1] !==
        this.listTransactions[this.listTransactions.length - 1]
      )
        this.pagination.currentPage++;
    },
  },

  computed: {
    filterChangeTrigger() {
      return this.startDate + this.endDate + this.type;
    },

    queriedData() {
      let result = this.listTransactions;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.listTransactions.length;
    },
  },

  watch: {
    filterChangeTrigger(value) {
      //console.log(value);
      if (
        (this.startDate != null &&
          this.startDate.getHours() +
            this.startDate.getMinutes() +
            this.startDate.getSeconds() !=
            0) ||
        (this.endDate != null &&
          this.endDate.getHours() +
            this.endDate.getMinutes() +
            this.endDate.getSeconds() !=
            0)
      ) {
        return;
      } else this.startFilter();
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>
<style scoped>
.pagination {
  color: rgba(0, 0, 0, 0.301);
  font-size: 13px;
}
.formActions {
  display: flex;
  justify-content: space-between;
}

.table_success {
  background-color: rgba(253, 255, 132, 0.336);
}
.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
.deposit {
  background: rgba(179, 152, 0, 0.404);
}
</style>
